import { useAuthStore } from '../stores/authStore';
import type { Role } from '@tellowup/db';

export function useRole(): Role | null {
  const user = useAuthStore((s) => s.user);
  return user?.role ?? null;
}
